import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger } from "@nextui-org/react";
import PropTypes from "prop-types";

import { Row, SpicyButton, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

import TextStyles from "../common/TextStyles";

const MemoryEditorDropdown = ({ onEdit, onDelete, onPinnedToggle, isPinned }) => {
  const { t } = useTranslation();
  return (
    <Dropdown offset={-20} crossOffset={-50} classNames={{ trigger: TextStyles.dropdown.trigger }} style={{ zIndex: 10000000 }}>
      <DropdownTrigger>
        <SpicyButton isIconOnly variant="primary_smallest">
          <Icon icon={IconVariants.THREE_DOTS} size={IconSize.SMALL} className="opacity-95" />
        </SpicyButton>
      </DropdownTrigger>
      <DropdownMenu classNames={TextStyles.dropdown.menu} className="w-full" aria-label="memory options">
        <DropdownSection classNames={TextStyles.dropdown.section}>
          <DropdownItem classNames={TextStyles.dropdown.item_primary} onPress={onEdit} textValue={t("chat:modal.memories.dropdown.edit")}>
            <Row justify="between">
              <Text variant={"md"}>
                <Trans i18nKey="chat:modal.memories.dropdown.edit" />
              </Text>
              <Icon icon={IconVariants.EDIT} size={IconSize.SMALL} />
            </Row>
          </DropdownItem>
        </DropdownSection>
        <DropdownSection classNames={TextStyles.dropdown.section}>
          <DropdownItem
            classNames={TextStyles.dropdown.item_primary}
            onPress={onPinnedToggle}
            textValue={isPinned ? t("chat:modal.memories.dropdown.unpin") : t("chat:modal.memories.dropdown.pin")}
          >
            <Row justify="between">
              <Text variant={"md"}>
                {isPinned ? <Trans i18nKey="chat:modal.memories.dropdown.unpin" /> : <Trans i18nKey="chat:modal.memories.dropdown.pin" />}
              </Text>
              <Icon icon={IconVariants.PIN} size={IconSize.SMALL} />
            </Row>
          </DropdownItem>
        </DropdownSection>
        <DropdownSection classNames={TextStyles.dropdown.section}>
          <DropdownItem
            classNames={TextStyles.dropdown.item_danger}
            color="danger"
            onPress={onDelete}
            textValue={t("chat:modal.memories.dropdown.delete")}
          >
            <Row justify="between">
              <Text variant={"md"} type={"error"}>
                <Trans i18nKey="chat:modal.memories.dropdown.delete" />
              </Text>
              <Icon icon={IconVariants.TRASH} size={IconSize.MEDIUM} className="text-red-600 mr-[3px]" />
            </Row>
          </DropdownItem>
        </DropdownSection>
      </DropdownMenu>
    </Dropdown>
  );
};

MemoryEditorDropdown.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onPinnedToggle: PropTypes.func,
  isPinned: PropTypes.bool,
};

export default MemoryEditorDropdown;
